/* @flow */

import type { $WidgetEnvConfiguration } from '../types/WidgetEnvConfiguration';
import Endpoints from 'CoreConstants/Endpoints';
import Environments from 'CoreConstants/Environments';
import HereMapsCredentials from 'CoreComponents/MapProviders/HereMaps/HereMapsCredentials';

const config: $WidgetEnvConfiguration = {
  env: Environments.ENV_TEST,
  configurationServiceEndpointInternal: Endpoints.INTERNAL.DSW.CMS.TEST,
  configurationServiceEndpointExternal: Endpoints.EXTERNAL.CMS.TEST,
  dealerServiceEndpointInternal: Endpoints.INTERNAL.DSW.DMS.TEST,
  dealerServiceEndpointExternal: Endpoints.EXTERNAL.DMS.TEST,
  mapProviders: {
    hereMaps: {
      appId: HereMapsCredentials.DEV_APP_ID,
      appCode: HereMapsCredentials.DEV_APP_CODE,
      useCIT: true
    }
  }
};

export default config;
